/* Normalize legacy Journal rich text at render time, without changing admin content.
 * Only roots explicitly opted in by main-article are touched. Plaid Check is deferred.
 */
(() => {
  if (window.cgJournalLayout) return;
  const text = (node) => (node.textContent || '').replace(/[\s\u200b]+/g, ' ').trim();
  const blocks = 'p,div,h1,h2,h3,h4,h5,h6,pre';
  const protectedContent = 'img,picture,video,audio,iframe,svg,canvas,object,embed,hr,table,ul,ol,form,input,button,script,style,[id],a[name],[data-journal-preserve]';

  function removeSpacers(root) {
    root.querySelectorAll('meta[charset]').forEach(node => node.remove());
    // Work inside-out. Do not remove empty embeds, anchors, controls or media.
    [...root.querySelectorAll(blocks)].reverse().forEach(node => {
      if (!text(node) && !node.matches(protectedContent) && !node.querySelector(protectedContent)) node.remove();
    });
  }

  function clearSpacing(root) {
    root.querySelectorAll(`${blocks},img,figure,figcaption`).forEach(node => {
      if (node.closest('table,pre,form,[data-journal-preserve]')) return;
      Array.from(node.style).filter(property => /^(margin|padding)(-|$)/.test(property)).forEach(property => node.style.removeProperty(property));
    });
  }

  function splitParagraphs(root) {
    for (const paragraph of [...root.querySelectorAll('p')]) {
      if (paragraph.id || paragraph.closest('pre,table,blockquote,[data-journal-preserve]') || paragraph.querySelector('img,iframe,video')) continue;
      const nodes = [...paragraph.childNodes];
      const groups = [[]];
      let split = false;
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].nodeName === 'BR') {
          let j = i + 1;
          while (j < nodes.length && nodes[j].nodeType === 3 && !text(nodes[j])) j++;
          if (nodes[j]?.nodeName === 'BR') {
            groups.push([]); split = true; i = j; continue;
          }
        }
        groups[groups.length - 1].push(nodes[i]);
      }
      if (split) paragraph.replaceWith(...groups.map(group => {
        const part = paragraph.cloneNode(false);
        part.append(...group);
        return part;
      }));
    }
  }

  function mediaFigures(root) {
    for (const image of [...root.querySelectorAll('img')]) {
      if (image.closest('figure,table,li,blockquote,h1,h2,h3,h4,h5,h6,[data-journal-preserve]')) continue;
      const block = image.closest('p,div');
      if (!block || block === root || !root.contains(block) || block.id) continue;
      // Lift the existing media branch, retaining linked images and picture/source.
      let branch = image;
      while (branch.parentElement !== block && !text(branch.parentElement) && branch.parentElement.querySelectorAll('img').length === 1) branch = branch.parentElement;
      if (branch.parentElement !== block) continue; // Mixed inline text: leave intact.
      const before = block.cloneNode(false);
      const after = block.cloneNode(false);
      while (block.firstChild !== branch) before.append(block.firstChild);
      const figure = document.createElement('figure');
      figure.className = 'cg-journal-media';
      figure.append(branch);
      while (block.firstChild) after.append(block.firstChild);
      block.replaceWith(before, figure, after);
    }
    removeSpacers(root);
  }

  function isCaption(node) {
    if (!node || !node.matches('p,div') || node.querySelector('img,video,iframe,figure,h1,h2,h3,h4,h5,h6')) return false;
    const value = text(node);
    if (!value || value.length > 240) return false;
    const links = [...node.querySelectorAll('a[href]')].filter(link => text(link));
    if (links.length === 1 && text(links[0]) === value) {
      try {
        const url = new URL(links[0].href, location.href);
        return url.origin === location.origin && /\/products\/[^/]+\/?$/.test(url.pathname);
      } catch (_) { return false; }
    }
    return /^Photography\s/i.test(value);
  }

  function captions(root) {
    for (const figure of root.querySelectorAll('figure.cg-journal-media')) {
      const next = figure.nextElementSibling;
      if (!isCaption(next)) continue;
      const caption = document.createElement('figcaption');
      caption.append(...next.childNodes);
      // Legacy captions can include copied Polaris dialog/container markup.
      // Unwrap only inside a positively identified caption; keep links/emphasis.
      [...caption.querySelectorAll('div,p,span')].reverse().forEach(node => node.replaceWith(...node.childNodes));
      caption.querySelectorAll('br,meta').forEach(node => node.remove());
      figure.append(caption);
      next.remove();
    }
  }

  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-journal-layout]')];
    if (scope.matches?.('[data-journal-layout]')) roots.unshift(scope);
    for (const root of roots) {
      if (root.dataset.journalLayout === 'deferred' || root.classList.contains('cg-journal-prose')) continue;
      removeSpacers(root);
      clearSpacing(root);
      splitParagraphs(root);
      mediaFigures(root);
      captions(root);
      // Breaks attached to media-only wrappers are editor spacing, not prose.
      root.querySelectorAll('figure.cg-journal-media br').forEach(node => node.remove());
      root.classList.add('cg-journal-prose');
    }
  }
  window.cgJournalLayout = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
